export enum ClaimsRoutingEnum {
    DamageClaim = 'schadeclaim',
}
